import { useState } from "react";
import { MutationOptions } from "@apollo/client";
import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import Textarea from "ds/components/Textarea";
import Typography from "ds/components/Typography";

import useStopScanRun, { ScanRunForStop } from "../useStopScanRun";

type StopScanRunModalProps = {
  scanRun: ScanRunForStop;
  refetchQueries?: MutationOptions["refetchQueries"];
};

const StopScanRunModal = create(function StopScanRunModal({
  scanRun,
  refetchQueries,
}: StopScanRunModalProps) {
  const modal = useModal();
  const [note, setNote] = useState("");
  const { stop, isStopping } = useStopScanRun({ scanRun, refetchQueries });

  const handleConfirm = () => {
    stop(note).then(() => modal.hide());
  };

  return (
    <DeleteConfirmationModal
      title="Stop scan run"
      confirmationButtonLabel="Stop scan run"
      onConfirm={handleConfirm}
      isLoading={isStopping}
      isDismissable={!isStopping}
    >
      <ConfirmationModalMessage>
        <Typography tag="div">Are you sure you want to stop this scan run?</Typography>
        <Typography tag="div" margin="x-large 0">
          If yes, you can leave an optional note explaining why
        </Typography>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} />
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showStopScanRunModal = (props: StopScanRunModalProps) =>
  show(StopScanRunModal, props);
